'use strict';
var $ = require('jquery');

function init() {
	if (document.querySelector(".characterMaximumMessage")) {
		function updateCharacterCounts() {
			var characterCounts = document.querySelectorAll(".characterMaximumMessage span[data-for]");
			for (let i = 0; i < characterCounts.length; i++) {
				var characterCount = characterCounts.item(i);
				characterCount.innerHTML = document.querySelector(".hasMaxLengthMessage[name$=':" + characterCount.getAttribute("data-for") + "']").value.length;
			}
		}
		$(document).on('keyup paste change blur', ".hasMaxLengthMessage", function(event) {
			updateCharacterCounts();
		});
		updateCharacterCounts();
	}
}

module.exports = {
	init: init
}